// extracted by css-extract-rspack-plugin
export default {"folderWrapper":"folder-wrapper--ZDNRWzrRpewsWCzc"};